<!-- @format -->

@if (hasValue) {
  <div>
    @if (localizedMarkupStringValue) {
      <sis-localized-markup-string-view [language]="language" [content]="localizedMarkupStringValue"></sis-localized-markup-string-view>
    }
    @if (localizedStringValue) {
      <span>{{ localizedStringValue | localizedString: language }}</span>
    }
  </div>
}
@if (!hasValue) {
  <span>
    <sis-icon icon="alert-fill-attention"></sis-icon>
    <span class="sis-placeholder" translate="STUDIES.COURSE_UNIT_INFO_MODAL.NO_CONTENT_IN_SELECTED_LANGUAGE"></span>
  </span>
}
